import * as React from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { EventReport, EventReportFilter } from '../../core/api/clients';
import useGetFilteredEventReports from '../../core/api/hooks/event-report/useGetFilteredEventReports';
import useEventReportFilters from '../../core/hooks/incident/useEventReportFilters';

type UnattachedEventReportsWithFilterRenderProps = {
  activeFilters: EventReportFilter[];
  eventReports: EventReport[];
  onFilterAdd: (eventReportFilter: EventReportFilter) => void;
  onFilterRemove: (eventReportFilter: EventReportFilter) => void;
};

interface UnattachedEventReportsWithFilterProps {
  render: (renderProps: UnattachedEventReportsWithFilterRenderProps) => React.JSX.Element;
  initialFilters?: EventReportFilter[];
  attachedReports?: EventReport[];
}

function UnattachedEventReportsWithFilter({
  render,
  initialFilters,
  attachedReports = [],
}: UnattachedEventReportsWithFilterProps): React.JSX.Element {
  const {
    eventReportFilters,
    addEventReportFilter,
    removeEventReportFilter,
  } = useEventReportFilters();

  const {
    data: allEventReports,
    mutate: refetchEventReports,
  } = useGetFilteredEventReports();

  React.useEffect(() => {
    if (initialFilters !== undefined) {
      initialFilters.forEach((filter) => {
        addEventReportFilter(filter);
      });
    }
  }, []);

  React.useEffect(() => {
    refetchEventReports(eventReportFilters);
  }, [eventReportFilters, attachedReports]);

  return (
    <React.Fragment>
      {render({
        activeFilters: eventReportFilters,
        eventReports: allEventReports ?? [] as EventReport[],
        onFilterAdd: addEventReportFilter,
        onFilterRemove: removeEventReportFilter,
      })}
    </React.Fragment>
  );
}

export default UnattachedEventReportsWithFilter;
